let $ = require('jquery');
import _ from "underscore";
import {setElementsFromScope, handleDisplayForV2, combineElements, insertTextAndClean} from "../../utilities/selectorHelpers";
import {isPresent, merge} from "../../utilities/general";

// FACTORY
function pagination(el, options){
  if(el && el.length){
    if(el.data('pagination')){
      const paginator = el.data('pagination');
      paginator.setOptions(options);
      return paginator;
    }
    else{
      const paginator = new Pagination(el, options);
      return paginator;
    }
  }
}



const elementsMap = {
  prevBtn: ".pagination-prev-btn",
  nextBtn: ".pagination-next-btn",
  pageInfo: ".pagination-page-info",
  itemsPerPageSelect: ".pagination-select",
  totalRowsHiddenInput: ".pagination-total-rows",
};


// DOC:
// options.tableData =
// {
//    // perPageSize()
//    size: 20,
//    // currentPageNumber()
//    number: 1,
//    // totalResults() - the total results of ALL pages as number
//    totalElements: 100,
//    
// }

function Pagination(el, opts={}) {
  const self = this;
  $ = opts.$ || $;
  const data = {};
  let options = {
    tableData: {},
    els: {},
    lang: {}
  };

  self.setOptions = setOptions;
  self.setTableData = setTableData;


  setOptions(opts);

  function init(){
    unbindElements();
    setElements();
    setDataAttrs();
    render();
    bindElements();
  }


  function render(){
    renderPagination();
  }


  function setElements(){
    setElementsFromScope(options.els, elementsMap, el);
    options.els.paginationOuter = el;
  }

  function setDataAttrs(){

    data.paginationText = options.lang['lookup-filter-pagination-showing'];
  }

  function setTableData(data){
    options.tableData = merge(options.tableData, data, {clone: true});
    renderPagination();
  }

  function setOptions(opts={}){
    options = merge(options, opts, {clone: true});
    init();
  }

  function bindElements(){

  }

  function unbindElements(){
    if(_.keys(options.els).length){
      // unbind specific listeners
    }
  }

  function renderPagination(){
    insertTextAndClean(options.els.pageInfo, buildPageInfoText());
    handleDisabledBtns();
    options.els.totalRowsHiddenInput.val(totalResults());
    options.els.itemsPerPageSelect.val(perPageSize());
  };

  function handleDisabledBtns(){
    handleDisabledNextBtn();
    handleDisabledPrevBtn();
  }

  function handleDisabledNextBtn(){
    if(isBeforeLastPage()){
      options.els.nextBtn.removeClass('disabled');
      // yeah...the other external js file in the hc-portlet filters.js file
      // decided to put this attribute on the parent of the actual link you
      // click on...so I have to traverse up to the parent to grab it
      options.els.nextBtn.parent().data('next-page', nextPageNumber());
    }
    else{
      options.els.nextBtn.addClass('disabled');
      options.els.nextBtn.parent().data('next-page', null);
    }
  }

  function handleDisabledPrevBtn(){
    if(!isFirstPage()){
      options.els.prevBtn.removeClass('disabled');
      options.els.prevBtn.parent().data('previous-page', prevPageNumber());
    }
    else{
      options.els.prevBtn.addClass('disabled');
      options.els.prevBtn.parent().data('previous-page', null);
    }
  }


  function buildPageInfoText(){
    if(hasTableData()){
      return `${paginationText} ${exclusiveResultsShownTotal()} - ${computedInclusiveResultsShownTotal()} of ${totalResults()} results.`
    }
    else{
      return "";
    }
  }

  // This is a smart function to return either
  // the total inclusive results or, if we've exceeded
  // the computed total then return just the totalResults
  function computedInclusiveResultsShownTotal(){
    if(isBeforeLastPage()){
      return inclusiveResultsShownTotal();
    
    }
    else{
      return totalResults();
    }
  }

  // the total amount of records up-to-and-including current page
  function inclusiveResultsShownTotal(){
    return perPageSize() * nextPageNumber();
  }

  // the total amount of records up-to-excluding current page (add 1 after for range)
  function exclusiveResultsShownTotal(){
    return (perPageSize() * currentPageNumber()) + 1;
  }

  function totalResults(){
    return getTableData().totalElements;
  }

  function hasTableData(){
    return totalResults() > 0;
  }

  function isFirstPage(){
    return currentPageNumber() <= 0;
  }

  function isBeforeLastPage(){
    return totalResults() > inclusiveResultsShownTotal();
  }

  function perPageSize(){
    return getTableData().size;
  }

  function currentPageNumber(){
    return getTableData().number;
  }



  function nextPageNumber(){
    return currentPageNumber() + 1;
  }

  function prevPageNumber(){
    return currentPageNumber() - 1;
  }

  function getTableData(){
    return options.tableData.page;
  }
}

export {Pagination};
export default pagination;


// WEBPACK FOOTER //
// ./src/components/pagination/pagination.js